import { Injectable } from '@angular/core';
import { BackendService } from '@toro/common/shared/services/new-http/backend.service';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { filter } from 'rxjs/operators';

const symbolsAgreement = require('./assets/symbols-agreement.json');

export class AgreementAcceptPayload {
    constructor(
        public contractGuid: string,
        public status: boolean,
    ) { }
}

@Injectable({ providedIn: 'root' })
export class CheckoutTermAcceptService {

    constructor(
        private backendService: BackendService,
        private store: Store<AppState> 
    ) {}

    public sessionId: string;

    private agreementTermUrl = '/agreement/v1.1/agreement'

    public getAgreementTerm(symbol: string) {
        const agreementTermHash = symbolsAgreement["data"].find(data => data.symbol === symbol).hash;

        try {
            return this.backendService.api.get(
                `${this.agreementTermUrl}/${agreementTermHash}`
            )   
        } catch (error) {
            console.error(error);
        }
    }

    public async acceptTerm(payload: AgreementAcceptPayload) {
        try {
            return await this.backendService.api.post(
                `${this.agreementTermUrl}/accept`, 
                payload
            ).subscribe()
        } catch (error) {
            console.error(error);
        }
    }

    public checkAcceptedContract() {
        try {
            this.fillSessionId();
            return this.backendService.api.get(
                `${this.agreementTermUrl}/accept`,
            );
        } catch (error) {
            console.error(error);
        }
    }

    private fillSessionId = () => {
        this.store
            .select(({authentication}) => authentication.currentUser)
            .pipe(
                filter((authentication) => !!authentication)
            )
            .subscribe((user) => {
                this.sessionId = user.sessionId
            })
    }
}
